module.exports = __webpack_public_path__ + "img/main-picture.ff3bf85b.png";